// 营销页全部文案。接多语言时整份平移成 locales/zh.json，结构即 key。
export const zh = {
  nav: {
    home: '返回首页',
    stories: '作品案例',
    how: '工作原理',
    blog: '博客',
    faq: '常见问题',
    login: '登录',
    start: '开始创作',
    openMenu: '打开菜单',
    closeMenu: '关闭菜单',
  },
  hero: {
    titleLines: ['把复杂知识', '讲成动画'],
    lead: '输入一个主题，几分钟后得到一支配好画面、配音和字幕的图解视频。',
    inputLabel: '视频主题',
    placeholder: '比如：天空为什么是蓝色的？',
    submit: '生成图解视频',
    submitShort: '生成',
    chips: ['天空为什么是蓝色的？', '黑洞是怎么形成的', '复利为什么这么厉害'],
    altStart: '也可以从一个网址，或一段写好的讲稿开始',
    videoLabel: '图解视频成片示例',
  },
  stories: {
    eyebrow: '作品墙',
    title: '每一支，都从一个主题开始',
    lead: '向下滚动，作品带会跟着你移动。',
    tileLabel: '动态视频作品',
  },
  about: {
    titleLines: ['每个复杂概念，', '都值得被看懂。'],
    body: '不是把文字塞进画面，而是先找到知识的结构，再用镜头、图形和节奏，让每个概念被真正理解。',
    presenterAlt: '3D 讲解员',
  },
  growth: {
    titleSerif: 'Ideas grow',
    titleSans: 'into stories',
    subtitle: '想法，会长成故事',
    left: '每一层信息里都藏着一个故事。移动鼠标寻找它，点击画面，让你发现的内容留下来。',
    right: '从主题、知识结构到镜头语言，把抽象概念一层层变成看得见的叙事。',
    cta: '看看怎么完成',
    hint: '移动预览 · 点击生长',
    touchHint: '轻点画面，让想法生长',
    clear: '清空',
  },
  how: {
    title: '五步完成',
    lead: '从一个主题到一支完整的图解视频，中间的脚本、画面、配音都由 AI 完成，你只需要确认和修改。',
    steps: [
      ['01', '给出一个主题', '一句你想讲清楚的话就够了。AI 会先判断受众、目标和最合适的讲法。'],
      ['02', '拆成可视化脚本', '把知识拆成有因果、有节奏的镜头，为每一幕找到真正能解释问题的画面。'],
      ['03', '生成画面与动画', '围绕每个知识点生成匹配的画面，用镜头运动把信息之间的关系讲明白。'],
      ['04', '配音与字幕', '自动配音并生成字幕，节奏和画面对齐，静音观看也能看懂。'],
      ['05', '修改并导出', '逐个场景调整画面、文案和节奏，满意后导出高清成片，直接发布。'],
    ] as [string, string, string][],
  },
  founder: {
    eyebrow: '创始人的话',
    quote: '讲清楚一个概念，往往比懂得它更难。写讲稿要一天，做成动画要一周。我们做这个产品，是想把那一周缩短到几分钟：你只需要说出想讲什么，剩下的交给我们。',
    name: '[创始人姓名]',
    role: '创始人',
  },
  blog: {
    eyebrow: '博客',
    title: '我们在想什么，在做什么，以及为什么',
    all: '全部文章',
    posts: [
      { kind: '观点', title: '为什么我们先做图解视频', summary: '讲清楚一个概念，比介绍一个产品更难，也更值得被自动化。我们为什么把第一步放在知识讲解上。', date: '日期待定', cover: 'linear-gradient(135deg,#1B1F5E,#0C0C0C)' },
      { kind: '产品更新', title: '一个输入框，三种开始方式', summary: '主题、讲稿或一个网址。我们如何把三种输入收进同一个输入框，又不让它变复杂。', date: '日期待定', cover: 'linear-gradient(135deg,#0F5F7A,#0B1E26)' },
      { kind: '幕后', title: '一支图解视频是怎么生成的', summary: '从拆解知识结构、写脚本，到逐个场景生成画面和配音，中间每一步都发生了什么。', date: '日期待定', cover: 'linear-gradient(135deg,#6B3A12,#1E1006)' },
    ],
  },
  faq: {
    title: '常见问题',
    items: [
      ['需要会剪辑或做动画吗？', '不需要。输入一个主题，AI 会先写脚本，再逐个场景生成画面、配音和字幕。每个场景生成好就能看到。'],
      ['可以用我自己写好的讲稿吗？', '可以。在工作台选择「逐字稿」，粘贴 40 到 2,000 字的讲稿，我们会一字不改，按内容拆成场景。'],
      ['生成后还能修改吗？', '可以。每个场景的画面、文案和节奏都能单独调整，满意后再导出。'],
      ['支持哪些画面比例？', '支持 16:9 横屏和 9:16 竖屏，可以直接用于视频号、B 站、抖音等平台。'],
    ] as [string, string][],
  },
  footer: {
    ctaEyebrow: '一个主题就够了',
    ctaTitleLines: ['让知识', '开始流动'],
    cta: '开始创作',
    backToTop: '返回顶部',
    tagline: '把复杂知识变成看得懂、记得住、愿意分享的图解视频。',
    product: '产品',
    workspace: '进入工作台',
    legal: '法律条款',
    privacy: '隐私政策',
    terms: '服务条款',
    copyright: '© 2026 Accrobrief',
    languageLabel: '切换语言',
    comingSoon: '即将推出',
  },
};

export type Copy = typeof zh;
